import { useEffect } from "react";
import {
  installTawk,
  installYandexMetrika,
  installGtm,
  installGtag,
} from "./surface.js";

export function BrandSurfaceWidgets({ appId = "main" }) {
  useEffect(() => {
    installTawk(appId);
    installYandexMetrika(appId);
    installGtm(appId);
    installGtag(appId);
  }, [appId]);

  return null;
}
